import React from "react";

/** Separate help control shown beside the stage timer (not inside it). */
export default function StageHelpButton({ onClick }) {
  return (
    <button
      type="button"
      className="stage-escape-help"
      onClick={onClick}
      aria-label="How to play"
      title="How to play"
    >
      ?
    </button>
  );
}
